<template>
<div>
  <div class="d-flex" id="wrapper">
    <SideBar />
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
          <p class="text-primary mb-0 hover-cursor" style="cursor: pointer" @click="$router.push('/rental/upgrade')">&nbsp;Upgrade - Downgrade Unit</p>
          <p class="text-primary mb-0 hover-cursor">&nbsp;/ Detail / {{$route.params.id}}</p>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 grid-margin stretch-card card-div ">
            <div class="container px-0">
              <table>
                <tr>
                  <th colspan="3" class="py-2">
                    <h5>Upgrade / Downgrade Unit Detail
                      <span class="rounded py-1 px-2 bg-primary text-light" v-if="orderStatus == 'Pending'">{{orderStatus}}</span>
                      <span class="rounded py-1 px-2 bg-warning text-light" v-if="orderStatus == 'On Process'">{{orderStatus}}</span>
                      <span class="rounded py-1 px-2 bg-secondary text-light" v-if="orderStatus == 'Approved'">{{orderStatus}}</span>
                      <span class="rounded py-1 px-2 bg-info text-light" v-if="orderStatus == 'Done'">{{orderStatus}}</span>
                      <span class="rounded py-1 px-2 bg-danger text-light" v-if="orderStatus == 'Cancel'">{{orderStatus}}</span>
                    </h5>
                  </th>
                </tr>
                <tr>
                  <td class="align-top">Company Name</td>
                  <td class="align-top">&emsp;:&emsp;</td>
                  <td>
                    {{ dataDetail.companyName }}
                  </td>
                </tr>
                <tr>
                  <td class="align-top">Product Code</td>
                  <td class="align-top">&emsp;:&emsp;</td>
                  <td>
                    {{ dataDetail.orderLp }}
                  </td>
                </tr>
                <tr>
                  <td class="align-top">Serial Number</td>
                  <td class="align-top">&emsp;:&emsp;</td>
                  <td>
                    {{ dataDetail.orderSn }}
                  </td>
                </tr>
                <tr>
                  <td class="align-top">Start Rent</td>
                  <td class="align-top">&emsp;:&emsp;</td>
                  <td>
                    {{ dataDetail.startRent }}
                  </td>
                </tr>
                <tr>
                  <td class="align-top">End Rent</td>
                  <td class="align-top">&emsp;:&emsp;</td>
                  <td>
                    {{ dataDetail.endRent }}
                  </td>
                </tr>
                <tr v-if="(orderStatus == 'Approved' || orderStatus == 'Done') && dataDetail.dataTicket">
                  <td class="align-top">Ticket Number</td>
                  <td class="align-top">&emsp;:&emsp;</td>
                  <td>
                    <div class="text-primary" style="cursor: pointer" @click="$router.push('/resolution/detail/' + dataDetail.dataTicket.ticketId)">
                      <div class="d-flex">
                        <div class="mr-1">
                          {{ dataDetail.dataTicket.ticketHLP }}
                        </div>
                        <div class="badge-reso-pending text-center px-2" style="border-radius: 5px" v-if="dataDetail.dataTicket.status == 0">Pending</div>
                        <div class="badge-reso-confirmed text-center px-2" style="border-radius: 5px" v-if="dataDetail.dataTicket.status == 1">Confirmed</div>
                        <div class="badge-reso-scheduled text-center px-2" style="border-radius: 5px" v-if="dataDetail.dataTicket.status == 2">Scheduled</div>
                        <div class="badge-reso-repaired text-center px-2" style="border-radius: 5px" v-if="dataDetail.dataTicket.status == 3">Repaired</div>
                        <div class="badge-reso-solved text-center px-2" style="border-radius: 5px" v-if="dataDetail.dataTicket.status == 4">Solved</div>
                        <div class="badge-reso-repaired text-center px-2" style="border-radius: 5px" v-if="dataDetail.dataTicket.status == 5">Done</div>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
              <!-- <button class="btn btn-sm btn-info mt-3" @click="updateSn">Update SN</button> -->
            </div>
            <div class="row mr-1 my-4">
              <div class="col-md-12 grid-margin stretch-card card-div">
                <div class="container">
                  <h5 class="card-title">Log Order</h5>
                  <div class="card">
                    <div class="card-body">
                      <table class="fixed_header table-bordered table-striped">
                        <tbody class="full-width">
                          <tr>
                            <th style="min-width: 150px;">When</th>
                            <th style="min-width: 500px;">What</th>
                            <th>Who</th>
                          </tr>
                          <tr v-if="dataLogOrder.length == 0">
                            <td colspan="3">Tidak ada Log</td>
                          </tr>
                          <tr v-else v-for="(data,i) in dataLogOrder" :key="i">
                            <td>{{ data.time }}</td>
                            <td v-html="data.text"></td>
                            <td>{{ data.ids }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-lg-6">
                  <table>
                    <tr>
                      <th colspan="3" class="py-2">
                        <div class="d-flex">
                          <h5>Spesifikasi Awal</h5>
                        </div>
                      </th>
                    </tr>
                    <tr>
                      <!-- <td class="align-top"><b>Product Name</b></td>
                      <td class="align-top">&emsp;:&emsp;</td> -->
                      <td>
                        <b><u> {{ oldSpec.productName }} </u></b>
                        <br/>
                      </td>
                    </tr>
                    <tr>
                      <div v-html="oldSpec.specification"></div>
                    </tr>
                    <tr>
                      <b>Harga</b> : Rp {{formatPrice(oldSpec.price)}}
                    </tr>
                    <!-- <tr>
                      <td class="align-top">Product Name</td>
                      <td class="align-top">&emsp;:&emsp;</td>
                      <td>
                        {{ oldSpec.name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="align-top">Processor</td>
                      <td class="align-top">&emsp;:&emsp;</td>
                      <td>
                        {{ oldSpec.processor }}
                      </td>
                    </tr>
                    <tr>
                      <td class="align-top">RAM</td>
                      <td class="align-top">&emsp;:&emsp;</td>
                      <td>
                        {{ oldSpec.ram }}
                      </td>
                    </tr>
                    <tr>
                      <td class="align-top">Storage</td>
                      <td class="align-top">&emsp;:&emsp;</td>
                      <td>
                        {{ oldSpec.storage }}
                      </td>
                    </tr>
                    <tr>
                      <td class="align-top">VGA</td>
                      <td class="align-top">&emsp;:&emsp;</td>
                      <td>
                        {{ oldSpec.vga }}
                      </td>
                    </tr>
                    <tr>
                      <td class="align-top">Price</td>
                      <td class="align-top">&emsp;:&emsp;</td>
                      <td>
                        Rp {{ oldSpec.price }}
                      </td>
                    </tr> -->
                  </table>
                </div>
                <div class="col-lg-6">
                  <table>
                    <tr>
                      <th colspan="3" class="py-2">
                        <h5>Spesifikasi Upgrade / Downgrade</h5>
                      </th>
                    </tr>
                    <tr>
                      <!-- <td class="align-top"><b>Product Name</b></td>
                      <td class="align-top">&emsp;:&emsp;</td> -->
                      <td>
                        <b><u> {{ newSpec.productName }} </u></b>
                        <br/>
                      </td>
                    </tr>
                    <tr>
                      <div v-html="newSpec.specification"></div>
                    </tr>
                    <tr>
                      <b>Harga</b> : Rp {{formatPrice(newSpec.price)}}
                    </tr>
                    <!-- <tr>
                      <td class="align-top">Product Name</td>
                      <td class="align-top">&emsp;:&emsp;</td>
                      <td>
                        {{ newSpec.name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="align-top">Processor</td>
                      <td class="align-top">&emsp;:&emsp;</td>
                      <td>
                        {{ newSpec.processor }}
                      </td>
                    </tr>
                    <tr>
                      <td class="align-top">RAM</td>
                      <td class="align-top">&emsp;:&emsp;</td>
                      <td>
                        {{ newSpec.ram }}
                      </td>
                    </tr>
                    <tr>
                      <td class="align-top">Storage</td>
                      <td class="align-top">&emsp;:&emsp;</td>
                      <td>
                        {{ newSpec.storage }}
                      </td>
                    </tr>
                    <tr>
                      <td class="align-top">VGA</td>
                      <td class="align-top">&emsp;:&emsp;</td>
                      <td>
                        {{ newSpec.vga }}
                      </td>
                    </tr>
                    <tr>
                      <td class="align-top">Price</td>
                      <td class="align-top">&emsp;:&emsp;</td>
                      <td>
                        Rp {{ newSpec.price }}
                      </td>
                    </tr> -->
                  </table>
                </div>
              </div>
              <div class="mt-5 mb-3">
                <div class="container">
                  <div class="row justify-content-end">
                    <button @click.prevent="editSpec" v-if="orderStatus == 'On Process' || orderStatus == 'Pending'" class="btn btn-sm mr-1 text-light btn-ubah">Ubah Spesifikasi</button>
                    <button class="btn btn-sm btn-dark mr-1" @click="downloadDocUpgrade" v-if="dataDetail.urlDoc && orderStatus !== 'Cancel'">Download Dokumen</button>
                    <button class="btn btn-sm btn-primary mr-1" @click="uploadModal" v-if="!dataDetail.urlDoc && orderStatus !== 'Cancel' && orderStatus !== 'Approved' && orderStatus !== 'Done'">Upload Dokumen</button>
                    <button class="btn btn-sm btn-primary mr-1" @click="uploadModal" v-if="dataDetail.urlDoc && orderStatus !== 'Cancel' && orderStatus !== 'Approved' && orderStatus !== 'Done'">Re-upload Dokumen</button>
                    <button class="btn btn-sm btn-info mr-1" @click="approve" v-if="orderStatus == 'On Process'">Approve</button>
                    <button class="btn btn-sm btn-info mr-1" @click="processUpgrade" v-if="orderStatus == 'Pending'">Proses</button>
                    <button class="btn btn-sm btn-danger" @click="cancelUpgrade" v-if="orderStatus !== 'Cancel' && orderStatus !== 'Approved' && orderStatus !== 'Done'">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="modalUploadUpgrade" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header mb-0">
          <div class="container">
            <div class="row justify-content-between">
              <h6>Upload Dokumen</h6>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
          </div>
        </div>
        <div class="modal-body mt-0">
          <input type="file" id="upgrade-file" @change="onFilePicked($event)">
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Batal</button>
          <button type="button" class="btn btn-primary btn-sm" :disabled="!fileName.length" @click="uploadDoc">Simpan</button>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import swal from 'sweetalert'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import SideBar from '../SideBar'
export default {
  name: 'DetailUpgrade',
  components: {
    SideBar,
    Multiselect
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      admin: '',
      adminId: '',
      dataDetail: {
        companyName: '',
        orderDetailsId: '',
        oldProductId: '',
        oldProductSpec: '',
        orderLp: '',
        orderSn: '',
        newProductId: '',
        newProductSpec: '',
        startRent: '',
        endRent: '',
        urlDoc: '',
        status: '',

      },
      oldSpec: {
        productName : '',
        specification : ''
      },
      newSpec: {
        productName: '',
        specification : ''
      },
      fileName: '',
      fileBase64: '',
      dataLogOrder: [],
      catalogData: [],
      orderStatus: '',
      //
      companies: [],
      companyCreate: '',
      selectCatalog: '',
      catalogData: [],
      selectVariant: '',
      selectCondition: '',
      conditions: [],
      productVariants: [],
      productTypes: [{
        id: 1,
        typeName: 'Laptop'
      }, {
        id: 2,
        typeName: 'CPU'
      }],
      selectType: '',
      selectName: '',
      productNames: [],
      createSn: '',
      createLp: '',
      createPrice: '',
      upgradeTypes: [{
        id: 1,
        name: 'Unit'
      }, {
        id: 2,
        name: 'Sparepart'
      }],
      selectTypeUpgrade: ''
    }
  },
  methods: {
    formatPrice(value) {
      let val = value;
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    getCompanyList() {
      this.$http.get(process.env.GET_LESSEE_COMPANY, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(response => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })

          } else {
            this.companies = response.data.content
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getProductName() {
      this.$http
        .post(
          process.env.GET_CATALOG_NAME, {
            catalogType: this.dataDetail.productType,
          }, {
            headers: {
              "Asani-Token": localStorage.getItem("jwt")
            },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            });

          } else if (response.data.status == 200) {
            let tester = []
            tester.splice(0, 1, response.data.content)
            console.log(tester[0])
            this.productNames = tester[0]
            // this.productNames = response.data.content
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },
    getVariant() {
      this.$http.post(process.env.GET_CATALOG_VARIAN, {
          catalogName: this.selectName.catalogName,
        }, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt")
          }
        })
        .then(res => {
          console.log(res)
          if (res.data.status == 200) {
            console.log(res.data)
            this.productVariants = res.data.content
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getCondition() {
      this.$http
        .post(
          process.env.GET_CATALOG_CONDITION, {
            catalogId: this.selectVariant.catalogId,
          }, {
            headers: {
              "Asani-Token": localStorage.getItem("jwt")
            },
          }
        )
        .then(res => {
          if (res.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            });

          } else if (res.data.status == 200) {
            this.conditions = res.data.content
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    downloadDocUpgrade() {
      window.open(this.dataDetail.urlDoc + '?token=' + localStorage.getItem('jwt'))
    },
    editSpec() {
      this.$router.push('/rental/upgrade/edit/' + this.$route.params.id + '?companyId=' + this.$route.query.companyId)
      console.log('opening modal...')
      this.companyCreate = ''
      this.createPrice = ''
      this.getCompanyList()
      // $('#modalEditSpecAwal').modal('show')
    },
    submitEditSpec() {
      this.$http.post(process.env.UPDATE_SN, {
        upId: parseInt(this.$route.params.id),
        companyId: this.companyCreate.companyId,
        orderDetailsId: this.dataDetail.orderDetailsId,
        productId: this.selectVariant.catalogId,
        condition: this.selectCondition,
        price: this.createPrice !== null ? parseInt(this.createPrice.replace(this.spaceRegex, ' ')) : parseInt(this.createPrice)
      }, {
        headers: {
          "Asani-Token": localStorage.getItem("jwt")
        }
      }).then(res => {
        console.log(res)
        if (res.data.status == 200) {
          swal('Success', 'Sukses Update Specification.', 'success')
          $('#modalEditSpecAwal').modal('hide')
          this.getDetail()
        } else {
          swal('Error', res.data.message, 'error')
          if (res.data.status == 401) {
            this.handleLogout()
          }
        }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    inputFormat(a) {
      return a.toLocaleString()
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    tandaPemisahTitik(b) {
      var _minus = false;
      if (b < 0) _minus = true;
      b = b.toString();
      b = b.replace(/\./g, "");
      b = b.replace("-", "");
      var c = "";
      var panjang = b.length;
      var j = 0;
      for (var i = panjang; i > 0; i--) {
        j = j + 1;
        if (j % 3 == 1 && j != 1) {
          c = b.substr(i - 1, 1) + "." + c;
        } else {
          c = b.substr(i - 1, 1) + c;
        }
      }
      if (_minus) c = "-" + c;
      return c;
    },
    inputPrice(index) {
      // this.createPrice.splice(index, 1, this.tandaPemisahTitik(this.createPrice))
      this.createPrice = this.tandaPemisahTitik(this.createPrice.toString())
    },
    approve() {
      if (this.dataDetail.urlDoc == null || this.dataDetail.urlDoc == '') {
        swal('Error', 'Dokumen belum diupload', 'error')
      } else if(!Number(this.$route.params.id) || !Number(this.dataDetail.orderDetailsId)) {
        swal('Error', 'Tipe data tidak sesuai', 'error')
      } else {
        swal({
            title: "Approve Upgrade",
            text: "Apakah anda akan menyetujui upgrade " + this.dataDetail.orderLp + '?',
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then((val) => {
            if (val) {
              this.$http.post(process.env.APPROVE_UPGRADE, {
                  upId: Number(this.$route.params.id),
                  orderDetailsId: Number(this.dataDetail.orderDetailsId)
                }, {
                  headers: {
                    "Asani-Token": localStorage.getItem("jwt")
                  }
                })
                .then(res => {
                  if (res.data.status == 200) {
                    swal('', 'Berhasil', 'success')
                      .then(val => {
                        this.getDetail()
                        this.getLog()
                      })
                  } else {
                    swal('', res.data.message, 'error')
                  }
                })
                .catch(error => {
                  swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                  }).then(v => {
                    if(error.response.data.status == 401) {
                      this.handleLogout()
                    }
                  })
                })
            } else {

            }
          })
      }
    },
    processUpgrade() {
      swal({
          title: "Proses Upgrade",
          text: "Apakah anda akan memproses upgrade " + this.dataDetail.orderLp + '?',
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
        .then((val) => {
          if (val) {
            this.$http.post(process.env.PROCESS_UPGRADE, {
                upId: this.$route.params.id
              }, {
                headers: {
                  "Asani-Token": localStorage.getItem("jwt")
                }
              })
              .then(res => {
                if (res.data.status == 200) {
                  swal('', 'Berhasil', 'success')
                    .then(val => {
                      this.getDetail()
                      this.getLog()
                    })
                } else {
                  swal('', res.data.message, 'error')
                }
              })
              .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                  button: "Ok",
                }).then(v => {
                  if(error.response.data.status == 401) {
                    this.handleLogout()
                  }
                })
              })
          } else {

          }
        })
    },
    cancelUpgrade() {
      swal("Alasan pembatalan:", {
          content: "input",
        })
        .then((value) => {
          if (value !== null) {
            this.$http.post(process.env.CANCEL_UPGRADE, {
                upId: this.$route.params.id,
                note: value
              }, {
                headers: {
                  "Asani-Token": localStorage.getItem("jwt")
                }
              })
              .then(res => {
                if (res.data.status == 200) {
                  swal('', 'Berhasil membatalkan', 'success')
                    .then(val => {
                      this.getDetail()
                      this.getLog()
                    })
                } else {
                  swal('', res.data.message, 'error')
                }
              })
              .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                  button: "Ok",
                }).then(v => {
                  if(error.response.data.status == 401) {
                    this.handleLogout()
                  }
                })
              })
              // swal("Error", error.message, "error");
          }
        });
    },
    onFilePicked(e) {
      const file = e.target.files[0]
      const fr = new FileReader()
      fr.readAsDataURL(file)
      fr.addEventListener('load', () => {
        let imgBase64 = fr.result.split("base64,")[1]
        let ext = file.name.toLowerCase().substring(file.name.toLowerCase().lastIndexOf('.') + 1)
        if (ext == "jpeg" || ext == "jpg" || ext == "png" || ext == 'pdf') {
          if (Math.round(file.size / 1024) > 5000) {
            swal('', 'Ukuran file tidak boleh lebih dari 5MB.', 'error')
          } else {
            this.fileName = file.name
            this.fileBase64 = imgBase64
            var fuData = document.getElementById('upgrade-file')
            // var FileUploadPath = fuData.value
            var reader = new FileReader()
            reader.onload = function (ev) {
              $('#logo_preview').attr('src', ev.target.result);
            }
            reader.readAsDataURL(fuData.files[0])
          }
        } else {
          swal('', 'Format salah', 'error')
        }
      })
    },
    uploadDoc() {
      this.$http.post(process.env.UPLOAD_DOC_UPGRADE, {
          upId: this.$route.params.id,
          fileName: this.fileName !== null ? this.fileName.replace(this.spaceRegex, ' ') : this.fileName,
          fileBase64: this.fileBase64
        }, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt")
          }
        })
        .then(res => {
          if (res.data.status == 200) {
            swal('', 'Dokumen berhasil diupload.', 'success')
            $('#modalUploadUpgrade').modal('hide')
            this.getDetail()
            this.getLog()
            this.fileName = ''
            this.fileBase64 = ''
          } else {
            swal('', res.data.message, 'error')
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
        // swal("Error", error.message, "error");
    },
    parseSpec(id, data, price) {
      let arr = data.split('/')
      let arrn = arr[0].split(' ')
      let temp = arrn[arrn.length - 1]
      let arrname = []
      for (let i = 0; i < arrn.length - 1; i++) {
        arrname.push(arrn[i])
      }
      // let proc = temp[temp.length]
      console.log(arrname.join(' '), temp)
      let datas = {
        id: id,
        name: arrname.join(' '),
        processor: temp,
        ram: arr[1],
        storage: arr[2],
        vga: arr[3],
        price: this.formatPrice(price)
      }
      return datas
    },
    getDetail() {
      this.$http.get(process.env.DETAIL_UPGRADE + this.$route.params.id, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt")
          }
        })
        .then(res => {
          if (res.data.status == 400) {

          } else if (res.data.status == 200) {
            this.dataDetail = res.data.content
            this.oldSpec = {
              productName : res.data.content.oldProductName,
              specification : res.data.content.oldProductSpec,
              price : res.data.content.oldPrice
            }
             this.newSpec = {
              productName : res.data.content.newProductName,
              specification : res.data.content.newProductSpec,
              price : res.data.content.newPrice
            }
            // this.oldSpec = this.parseSpec(res.data.content.oldProductId, res.data.content.oldProductSpec, res.data.content.oldPrice)
            // this.newSpec = this.parseSpec(res.data.content.newProductId, res.data.content.newProductSpec, res.data.content.newPrice)
            this.orderStatus = res.data.content.status
            console.log(this.newSpec)
          }
          console.log(res)
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    uploadModal() {
      $('#modalUploadUpgrade').modal('show')
    },
    getLog() {
      this.$http.get(process.env.LOG_URL + '/order_upgrade/' + this.$route.params.id, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt")
          }
        })
        .then(res => {
          console.log(res)
          if (res.data.status == 200) {
            this.dataLogOrder = res.data.content
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    toPage(e) {
      this.$router.push(e)
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('qc-cache')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin() {
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
        localStorage.removeItem('qc-cache')
      }
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true
        }
        if (this.permission[i] == "2.1") {
          this.viewOrder = true
        }
        if (this.permission[i] == "2.2") {
          this.editOrder = true
        }
        if (this.permission[i] == '3.1') {
          this.viewReturn = true
        }
        if (this.permission[i] == '3.2') {
          this.editReturn = true
        }
        if (this.permission[i] == '4.1') {
          this.viewProduct = true
        }
        if (this.permission[i] == '4.2') {
          this.editProduct = true
        }
        if (this.permission[i] == '5.1') {
          this.viewPairing = true
        }
        if (this.permission[i] == '5.2') {
          this.editPairing = true
        }
        if (this.permission[i] == '6') {
          this.viewReconcile = true
        }
        if (this.permission[i] == '7.1') {
          this.viewResolution = true
        }
        if (this.permission[i] == '7.2') {
          this.editResolution = true
        }
        if (this.permission[i] == '8.1') {
          this.viewLessor = true
        }
        if (this.permission[i] == '8.2') {
          this.editLessor = true
        }
        if (this.permission[i] == '9.1') {
          this.viewLessee = true
        }
        if (this.permission[i] == '9.2') {
          this.editLessee = true
        }
        if (this.permission[i] == '10') {
          this.viewEmployee = true
        }
      }
      if (this.viewOrder == false) {
        this.$router.push('/')
      }
    },

  },
  watch: {
    companyCreate: function (val) {
      this.selectType = ''
      this.selectName = ''
      this.createSn = val.sn
      this.createLp = val.code
      console.log(val)
      this.productTypes.forEach(el => {
        if (el.id == this.dataDetail.productType) {
          console.log(el)
          this.selectType = el
        }
      })
      if (this.selectType.id) {
        this.getProductName()
      }
    },
    selectName: function (val) {
      this.selectVariant = ''
      if (val.catalogName) {
        this.getVariant()
      }
    },
    selectVariant: function (val) {
      this.selectCondition = ''
      if (val.catalogId) {
        this.getCondition()
      }
    }
  },
  created() {
    this.cekLogin()
    this.cekPermission()
    this.admin = localStorage.getItem('admin_name')
    this.adminId = localStorage.getItem('admin_id')
    this.getLog()
    this.getDetail()
  }
}
</script>

<style scoped>
.multiselect div.multiselect__tags span.multiselect__single {
  padding-left: 0px;
  margin-bottom: 8px;
}

.rs-schedule {
  margin: 7px 0px;
}

.rs-po {
  margin: 7px 0px;
}

.rs-lessee {
  margin: 7px 0px;
}

.rs-ol-titik2 {
  width: 15px;
  margin: 7px 0px;
}

.tableFixHead {
  overflow-y: auto;
  height: 100px;
}

.tableFixHead thead th {
  position: sticky;
  top: 0;
}

.icon-verified {
  max-width: 22px;
  max-height: 22px;
  margin-right: 2px;
}

.multiselect.mandatory {
  height: calc(1.5em + .5rem + 2px);
}

table.mandatory-table td {
  margin-bottom: 10px;
}

.text-star {
  color: red;
  margin-bottom: 10px;
}

.link-company:hover {
  color: blue;
  cursor: pointer;
  text-decoration: underline;
}

.text-new {
  color: orange;
  font-weight: bold;
}

.font-black {
  color: black;
}

.nav-tabs {
  width: 48%;
}

.project-tab {
  padding: 0% 0% 2% 0%;
}

.project-tab #tabs {
  background: #007b5e;
  color: #eee;
}

.project-tab #tabs h6.section-title {
  color: #eee;
}

.project-tab #tabs .nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #0062cc;
  background-color: transparent;
  border-color: transparent transparent #f3f3f3;
  border-bottom: 3px solid !important;
  font-size: 16px;
  font-weight: bold;
}

.project-tab .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
  /*color: #0062cc;*/
  font-size: 16px;
  font-weight: 600;
}

.project-tab .nav-link:hover {
  border: none;
}

.project-tab thead {
  background: #f3f3f3;
  color: #333;
}

.project-tab a {
  text-decoration: none;
  color: #333;
  font-weight: 600;
}

.fa-check-circle {
  color: green;
}

.btn:focus {
  outline: none;
}

.btn-outline-right {
  border: 1px solid black;
  border-left: none;
}

.btn-outline-left {
  border: 1px solid black;
  border-right: none;
}

.two-button {
  display: flex;
  box-shadow: 2px;
}

.block {
  display: block;
  width: 100%;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  border-radius: 0px;
}

.font-red {
  color: red;
  margin-top: -15px;
}

.modal-dialog.modal-scroll {
  overflow-y: initial !important;
}

.modal-body.modal-scroll {
  height: 530px;
  overflow-y: auto;
}

.detail-order {
  color: blue;
  font-style: italic;
}

.detail-order:hover {
  cursor: pointer;
}

.product-name {
  margin-top: 6px;
  margin-left: -5px;
}

.delivery-sch {
  width: 199px;
  margin: 7px 0px;
}

.deliver-field {
  width: 84%;
}

.pickup-sch {
  width: 186px;
  margin: 7px 0px;
}

.stPrice-sch {
  width: 186px;
  margin: 7px 0px;
}

.delivery-titik2 {
  margin: 7px 0px;
  padding-right: 7px;
}

.qty-assignto {
  margin: 7px 0px;
  margin-left: 6px;
  margin-right: 5px;
}

.partnership-text {
  width: 195px;
  margin: 7px 0px;
}

.partnership-titik2 {
  margin: 7px 0px;
  padding-right: 7px;
}

.deliver-date {
  font-size: 14px;
  color: orange;
  font-weight: bold;
}

.total-rp {
  padding-left: 23px;
  padding-right: 20px;
}

.jarak-assigto {
  margin-left: 147px;
  margin-bottom: 6px;
  height: 18px;
}

.change_price {
  max-width: 150px;
  margin-right: 5px;
}

.edit-status {
  margin-bottom: 0
}

.permonth {
  margin: 5px 0px 5px 5px;
}

.text-partnership {
  margin-bottom: 0px;
}

.img-responsive {
  width: 250px;
  height: auto;
}

.process-vendor-new {
  max-width: 345px;
  margin: 5px 5px;
}

.process-qty-new {
  max-width: 62px;
  height: 41px;
}

.process-vendor {
  min-width: 345px;
  margin-bottom: 5px;
}

.process-qty {
  max-width: 80px;
  height: 42px;
}

.button-plus {
  bottom: 0px;
  right: 0px;
}

.input-title {
  margin: 0px 5px;
}

.input-title-new {
  margin: 0px 5px;
  width: 75%;
}

.input-one-line {
  display: flex;
}

.input-one-line-assign {
  display: flex;
  width: 100%;
}

.input-title-assign {
  margin: 0px 5px;
  width: 100%;
}

.input-title-assignto {
  margin: 0px 5px;
  width: 100%;
}

.input-title-qty {
  margin: 0px 5px;
  width: 100%;
}

.title-product {
  width: 100%;
  margin: 5px 0px;
}

.input-group-addon {
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #555;
  text-align: center;
  background-color: #eee;
  border: 1px solid #ccc;
  border-radius: 4px 0px 0px 4px;
  border-right: none;
}

.label-addon-rp {
  margin: 1px 0px;
}

.change-title {
  display: block;
}

.one-line {
  display: flex;
  margin: 5px 0px;
}

.one-line .ol-label-time {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label-reason {
  width: 88px;
  margin: 2px 0px;
}

.one-line .ol-label-price {
  width: 263px;
  margin: 2px 0px;
}

.one-line .ol-titik2 {
  width: 15px;
  margin: 2px 0px;
}

.one-line .ol-titik2-price {
  margin: 2px 0px;
}

.top-assignto {
  display: flex;
}

.btn-icon-assign {
  height: 37px;
  width: 103px;
  margin-top: 5px;
}

.one-line .ol-value {
  width: 100%;
  margin: 2px 0px;
}

.fixed_header {
  table-layout: fixed;
  border-collapse: collapse;
}

.fixed_header tbody {
  display: block;
  overflow: auto;
  max-height: 200px;
  width: 100%;
}

.fixed_header tbody.full-width tr td {
  width: 1578px;
}

.fixed_header thead tr {
  display: block;
}

.fixed_header th,
.fixed_header td {
  padding: 5px;
  text-align: left;
  width: 200px;
}

.fixed_header.payment th,
.fixed_header.payment td {
  padding: 5px;
  text-align: left;
  width: 217px;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 2px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover {
  text-decoration: none;
}

.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.pagg {
  display: inline-flex;
  overflow: auto;
}

.total-data {
  font-size: 14px;
  color: #343A40;
}

#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}

#c1 {
  float: left;
}

#c2 {
  float: right;
}

/*.table td, .table th {
    padding: 0.25rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
    }*/
.search-table {
  padding-bottom: 7px;
  margin-top: -5px;
  margin-left: -15px;
}

.active {
  color: #2797FB;
}

.right-dropdown {
  margin-left: 7px;
}

.account-div {
  margin: 2px 2px;
}

.right-arrow {
  margin-left: auto;
}

.brand-logo {
  width: 120px;
}

.menu-title {
  margin-left: 1.125rem;
}

.menu-title-order {
  margin-left: 1.95rem;
}

.menu-title-payment {
  margin-left: 1.525rem;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
}

li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
}

li a.active {
  background-color: #4CAF50;
  color: white;
}

li a:hover:not(.active) {
  background-color: #2797FB;
  color: white;
}

.nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
}

.nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
}

.nav-side-menu .toggle-btn {
  display: none;
}

.nav-side-menu ul,
.nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
}

.nav-side-menu ul :not(collapsed) .arrow:before,
.nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}

.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}

.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}

.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}

.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}

.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}

.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}

.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}

.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}

.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}

.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}

@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }

  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }

  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}

@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}

@media (max-width: 573px) {
  .mobile-div {
    padding: 2px 0px;
  }
}

.radius-6 {
  border-radius: 12px;
}

.btn-ubah {
  background: #437981;
  border-color: #40737a;
}

.btn-ubah:hover {
  background: #3c6c74;
  border-color: #39676d;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/DetailUpgrade.vue